import { motion } from "framer-motion";
import { Instagram, Mail, MessageCircle, ArrowUpRight } from "lucide-react";
import { LINKS } from "../lib/config";

export default function Contact({ onBook }) {
    const channels = [
        { icon: Instagram, label: "Instagram", value: "@_coach_amy_", href: LINKS.instagram },
        { icon: MessageCircle, label: "WhatsApp", value: "Scrivimi", href: LINKS.whatsapp },
        { icon: Mail, label: "Email", value: "Amanda.morani@hotmail.com", href: LINKS.email },
    ];

    return (
        <section id="contact" className="relative bg-powder py-24 md:py-40">
            <div className="max-w-[1600px] mx-auto px-5 md:px-12">
                <div className="max-w-3xl mx-auto">
                    <p className="text-xs uppercase tracking-[0.28em] font-sans text-ink-muted mb-6">
                        <span className="inline-block w-8 h-px bg-fuchsia align-middle mr-3" />
                        Restiamo in contatto
                    </p>
                    <motion.h2
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.9] text-ink mb-10"
                    >
                        Parliamone.<br />
                        <span className="italic text-fuchsia">Insieme.</span>
                    </motion.h2>

                    <div className="space-y-4">
                        {channels.map((c) => {
                            const Icon = c.icon;
                            return (
                                <a
                                    key={c.label}
                                    href={c.href}
                                    target={c.href.startsWith("mailto") ? undefined : "_blank"}
                                    rel="noopener noreferrer"
                                    data-testid={`contact-${c.label.toLowerCase()}`}
                                    className="group flex items-center justify-between border-t border-ink/15 py-5 md:py-6"
                                >
                                    <div className="flex items-center gap-4">
                                        <Icon size={22} className="text-fuchsia" />
                                        <span className="font-serif text-2xl md:text-3xl text-ink group-hover:text-fuchsia transition-colors duration-500">
                                            {c.label}
                                        </span>
                                    </div>
                                    <span className="font-sans text-sm text-ink-muted flex items-center gap-2">
                                        {c.value}
                                        <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-500" />
                                    </span>
                                </a>
                            );
                        })}
                    </div>

                    <button onClick={onBook} data-testid="contact-book-btn" className="btn-fuchsia mt-12">
                        Prenota una consulenza gratuita, in presenza o online
                        <ArrowUpRight size={18} />
                    </button>
                </div>
            </div>
        </section>
    );
}
